const translations = {
  en: {
    "Enter your email address to get started":
      "Enter your email address to get started",
    "Enter your phone number to get started":
      "Enter your phone number to get started",
    "Failed to send OTP to email": "Failed to send OTP to email",
    "Failed to send OTP to phone": "Failed to send OTP to phone",
    "Sign in with email": "Sign in with email",
    "Sign in with phone": "Sign in with phone",
    "By continuing, you acknowledge High Five Academy’s":
      "By continuing, you acknowledge High Five Academy’s",
    "Privacy Policy": "Privacy Policy",
    "Learn whatever you need to": "Learn whatever you need to",
    "Not a High Five Academy member yet?":
      "Not a High Five Academy member yet?",
    "Learn more": "Learn more",
    "Enter the verification code sent to":
      "Enter the verification code sent to",
    Code: "Code",
    "Verify Email Address": "Verify Email Address",
    "Verify Phone Number": "Verify Phone Number",
    "Request new code": "Request new code",
    wait: "wait",
    Email: "Email",
    "Phone Number": "Phone Number",
    "User not found": "User not found",
    "Filter countries...": "Filter countries...",
    "Filter...": "Filter...",
    "Login to your account": "Login to your account",
    "Invitation Code": "Invitation Code",
    "Continue with email": "Continue with email",
    "Continue with phone": "Continue with phone",
    "Enter your email to create an account and get started":
      "Enter your email to create an account and get started",
  },
  de: {
    "Enter your email address to get started":
      "Gib deine E-Mail-Adresse an, um loszulegen",
    "Enter your phone number to get started":
      "Gib deine Telefonnummeran, um loszulegen",
    "Failed to send OTP to email": "OTP konnte nicht gesendet werden",
    "Failed to send OTP to phone": "OTP konnte nicht gesendet werden",
    "Sign in with email": "Mit E-Mail anmelden",
    "Sign in with phone": "Mit Telefon anmelden",
    "By continuing, you acknowledge High Five Academy’s":
      "Indem du fortfährst, bestätigst du die",
    "Privacy Policy": "Datenschutzrichtlinien",
    "Learn whatever you need to": "Lerne hier und jetzt",
    "Not a High Five Academy member yet?":
      "Noch kein Mitglied der High Five Academy?",
    "Learn more": "Erfahre mehr",
    "Enter the verification code sent to":
      "Gib den Code ein, der auf folgende Adresse geschickt wurde:",
    Code: "Code",
    "Verify Email Address": "E-Mail-Adresse verifizieren",
    "Verify Phone Number": "Telefonnummer verifizieren",
    "Request new code": "Neuen Code anfordern",
    wait: "warten",
    Email: "E-Mail",
    "Phone Number": "Telefonnummer",
    "User not found": "Benutzer nicht gefunden",
    "Filter countries...": "Länder filtern...",
    "Filter...": "Filtern...",
    "Login to your account": "Melde dich bei deinem Konto an",
    "Invitation Code": "Einladungscode",
    "Continue with email": "Mit E-Mail fortfahren",
    "Continue with phone": "Mit Telefon fortfahren",
    "Enter your email to create an account and get started":
      "Gib deine E-Mail-Adresse ein, um ein Konto zu erstellen und loszulegen",
  },
  ar: {
    "Enter your email address to get started":
      "أدخل عنوان بريدك الإلكتروني للبدء",
    "Enter your phone number to get started": "أدخل رقم هاتفك للبدء",
    "Failed to send OTP to email": "فشل في إرسال OTP إلى البريد الإلكتروني",
    "Failed to send OTP to phone": "فشل في إرسال OTP إلى الهاتف",
    "Sign in with email": "تسجيل الدخول باستخدام البريد الإلكتروني",
    "Sign in with phone": "تسجيل الدخول باستخدام الهاتف",
    "By continuing, you acknowledge High Five Academy’s":
      "من خلال المتابعة، فإنك تقر بـ High Five Academy’s",
    "Privacy Policy": "سياسة الخصوصية",
    "Learn whatever you need to": "تعلم كل ما تحتاجه",
    "Not a High Five Academy member yet?":
      "ليس لديك عضوية في أكاديمية High Five بعد؟",
    "Learn more": "تعرف على المزيد",
    "Enter the verification code sent to": "أدخل رمز التحقق المرسل إلى",
    Code: "رمز",
    "Verify Email Address": "تحقق من عنوان البريد الإلكتروني",
    "Verify Phone Number": "تحقق من رقم الهاتف",
    "Request new code": "طلب رمز جديد",
    wait: "انتظر",
    Email: "البريد الإلكتروني",
    "Phone Number": "رقم الهاتف",
    "User not found": "المستخدم غير موجود",
    "Filter countries...": "تصفية البلدان...",
    "Filter...": "تصفية...",
    "Login to your account": "تسجيل الدخول إلى حسابك",
    "Invitation Code": "رمز الدعوة",
    "Continue with email": "متابعة باستخدام البريد الإلكتروني",
    "Continue with phone": "متابعة باستخدام الهاتف",
    "Enter your email to create an account and get started":
      "أدخل بريدك الإلكتروني لإنشاء حساب والبدء",
  },
  fr: {
    "Enter your email address to get started":
      "Entrez votre adresse e-mail pour commencer",
    "Enter your phone number to get started":
      "Entrez votre numéro de téléphone pour commencer",
    "Failed to send OTP to email":
      "Impossible d'envoyer le code OTP par e-mail",
    "Failed to send OTP to phone":
      "Impossible d'envoyer le code OTP par téléphone",
    "Sign in with email": "Se connecter avec e-mail",
    "Sign in with phone": "Se connecter avec téléphone",
    "By continuing, you acknowledge High Five Academy’s":
      "En continuant, vous confirmez la politique de confidentialité de High Five Academy",
    "Privacy Policy": "Politique de confidentialité",
    "Learn whatever you need to": "Apprenez ce que vous avez besoin",
    "Not a High Five Academy member yet?":
      "Pas encore membre d'High Five Academy ?",
    "Learn more": "En savoir plus",
    "Enter the verification code sent to":
      "Entrez le code de vérification envoyé à",
    Code: "Code",
    "Verify Email Address": "Vérifier l'adresse e-mail",
    "Verify Phone Number": "Vérifier le numéro de téléphone",
    "Request new code": "Demander un nouveau code",
    wait: "attendre",
    Email: "E-mail",
    "Phone Number": "Numéro de téléphone",
    "User not found": "Utilisateur non trouvé",
    "Filter countries...": "Filtrer les pays...",
    "Filter...": "Filtrer...",
    "Login to your account": "Se connecter à votre compte",
    "Invitation Code": "Code d'invitation",
    "Continue with email": "Continuer avec e-mail",
    "Continue with phone": "Continuer avec téléphone",
    "Enter your email to create an account and get started":
      "Entrez votre adresse e-mail pour créer un compte et commencer",
  },
  fa: {
    "Enter your email address to get started":
      "آدرس ایمیل خود را وارد کنید تا شروع کنید",
    "Enter your phone number to get started":
      "شماره تلفن خود را وارد کنید تا شروع کنید",
    "Failed to send OTP to email": "امکان ارسال کد OTP به ایمیل وجود ندارد",
    "Failed to send OTP to phone": "امکان ارسال کد OTP به تلفن وجود ندارد",
    "Sign in with email": "ورود با ایمیل",
    "Sign in with phone": "ورود با تلفن",
    "By continuing, you acknowledge High Five Academy’s":
      "در ادامه، شما polisiyeyi High Five Academy’s تایید می‌کنید",
    "Privacy Policy": "polisiyeyi",
    "Learn whatever you need to": "هر چیزی که نیاز دارید را یاد بگیرید",
    "Not a High Five Academy member yet?": "هنوز عضو High Five Academy نیستید؟",
    "Learn more": " Mehr erfahren",
    "Enter the verification code sent to": "کد تایید ارسال شده به را وارد کنید",
    Code: "کد",
    "Verify Email Address": "تایید ایمیل",
    "Verify Phone Number": "تایید شماره تلفن",
    "Request new code": "درخواست کد جدید",
    wait: "ожидание",
    Email: "ایمیل",
    "Phone Number": "شماره تلفن",
    "User not found": "کاربری یافت نشد",
    "Filter countries...": "فیلتر کشورها...",
    "Filter...": "فیلتر...",
    "Login to your account": "ورود به حساب شما",
    "Invitation Code": "کد دعوت",
    "Continue with email": "ادامه با ایمیل",
    "Continue with phone": "ادامه با تلفن",
    "Enter your email to create an account and get started":
      "ایمیل خود را وارد کنید تا حساب ایجاد کنید و شروع کنید",
  },
  tr: {
    "Enter your email address to get started":
      "Başlamak için e-posta adresinizi girin",
    "Enter your phone number to get started":
      "Başlamak için telefon numaranızı girin",
    "Failed to send OTP to email": "OTP e-postaya gönderilemedi",
    "Failed to send OTP to phone": "OTP telefonuna gönderilemedi",
    "Sign in with email": "E-posta ile giriş yap",
    "Sign in with phone": "Telefon ile giriş yap",
    "By continuing, you acknowledge High Five Academy’s":
      "Devam etmeyle, High Five Academy’nın gizlilik politikasını kabul ediyorsunuz",
    "Privacy Policy": "Gizlilik Politikası",
    "Learn whatever you need to": "İhtiyacınız olan her şeyi öğrenin",
    "Not a High Five Academy member yet?":
      "Henüz High Five Academy üyesi değil misiniz?",
    "Learn more": "Daha fazla bilgi edin",
    "Enter the verification code sent to": "Gönderilen doğrulama kodunu girin",
    Code: "Kod",
    "Verify Email Address": "E-posta Adresini Doğrula",
    "Verify Phone Number": "Telefon Numarasını Doğrula",
    "Request new code": "Yeni kod iste",
    wait: "bekle",
    Email: "E-posta",
    "Phone Number": "Telefon Numarası",
    "User not found": "Kullanıcı bulunamadı",
    "Filter countries...": "Ülkeleri filtrele...",
    "Filter...": "Filtrele...",
    "Login to your account": "Hesabınıza giriş yapın",
    "Invitation Code": "Davet Kodu",
    "Continue with email": "E-posta ile devam et",
    "Continue with phone": "Telefon ile devam et",
    "Enter your email to create an account and get started":
      "Başlamak için e-posta adresinizi girin ve hesabını oluşturun",
  },
  ru: {
    "Enter your email address to get started":
      "Введите свой адрес электронной почты, чтобы начать",
    "Enter your phone number to get started":
      "Введите свой номер телефона, чтобы начать",
    "Failed to send OTP to email":
      "Не удалось отправить OTP на электронную почту",
    "Failed to send OTP to phone": "Не удалось отправить OTP на телефон",
    "Sign in with email": "Войти с помощью электронной почты",
    "Sign in with phone": "Войти с помощью номера телефона",
    "By continuing, you acknowledge High Five Academy’s":
      "Продолжая, вы подтверждаете High Five Academy’s",
    "Privacy Policy": "Политика конфиденциальности",
    "Learn whatever you need to": "Узнайте все, что вам нужно",
    "Not a High Five Academy member yet?":
      "Вы еще не являетесь членом High Five Academy?",
    "Learn more": "Узнать больше",
    "Enter the verification code sent to":
      "Введите код подтверждения, отправленный на",
    Code: "Код",
    "Verify Email Address": "Проверить адрес электронной почты",
    "Verify Phone Number": "Проверить номер телефона",
    "Request new code": "Запросить новый код",
    wait: "ожидание",
    Email: "Электронная почта",
    "Phone Number": "Номер телефона",
    "User not found": "Пользователь не найден",
    "Filter countries...": "Фильтр стран...",
    "Filter...": "Фильтр...",
    "Login to your account": "Войти в свой аккаунт",
    "Invitation Code": "Код приглашения",
    "Continue with email": "Продолжить с электронной почтой",
    "Continue with phone": "Продолжить с номером телефона",
    "Enter your email to create an account and get started":
      "Введите свой адрес электронной почты, чтобы создать учетную запись и начать",
  },
  ps: {
    "Enter your email address to get started":
      "ایمیل خود را وارد کنید تا شروع کنید",
    "Enter your phone number to get started":
      "شماره تلفن خود را وارد کنید تا شروع کنید",
    "Failed to send OTP to email": "OTP به ایمیل ارسال نشد",
    "Failed to send OTP to phone": "OTP به تلفن ارسال نشد",
    "Sign in with email": "ورود با ایمیل",
    "Sign in with phone": "ورود با تلفن",
    "By continuing, you acknowledge High Five Academy’s":
      "متابعة شما تأیید می‌کند که High Five Academy’s",
    "Privacy Policy": "정책 конфиденциальности",
    "Learn whatever you need to": "هر چیزی که نیاز دارید را یاد بگیرید",
    "Not a High Five Academy member yet?": "هنوز عضو High Five Academy نیستید؟",
    "Learn more": " Mehr erfahren",
    "Enter the verification code sent to":
      "کد تایید را وارد کنید که به ایمیل یا تلفن ارسال شده است",
    Code: "کد",
    "Verify Email Address": "ایمیل را تأیید کنید",
    "Verify Phone Number": "تلفن را تأیید کنید",
    "Request new code": "کد جدید درخواست کنید",
    wait: "ожидание",
    Email: "ایمیل",
    "Phone Number": "تلفن",
    "User not found": "کاربری یافت نشد",
    "Filter countries...": "فیلتر کشور...",
    "Filter...": "فیلتر...",
    "Login to your account": "ورود به حساب شما",
    "Invitation Code": "کد دعوت",
    "Continue with email": "متابعة با ایمیل",
    "Continue with phone": "متابعة با تلفن",
    "Enter your email to create an account and get started":
      "ایمیل خود را وارد کنید تا حساب ایجاد کرده و شروع کنید",
  },
  uk: {
    "Enter your email address to get started":
      "Введіть свою електронну пошту, щоб почати",
    "Enter your phone number to get started":
      "Введіть свій номер телефону, щоб почати",
    "Failed to send OTP to email":
      "Не вдалося відправити OTP на електронну пошту",
    "Failed to send OTP to phone": "Не вдалося відправити OTP на телефон",
    "Sign in with email": "Увійти за допомогою електронної пошти",
    "Sign in with phone": "Увійти за допомогою номера телефону",
    "By continuing, you acknowledge High Five Academy’s":
      "Продовження означає, що ви підтверджуєте High Five Academy’s",
    "Privacy Policy": "Політика конфіденційності",
    "Learn whatever you need to": "Вивчіть все, що вам потрібно",
    "Not a High Five Academy member yet?": "Ще не є членом High Five Academy?",
    "Learn more": "Дізнатися більше",
    "Enter the verification code sent to":
      "Введіть код підтвердження, який був відправлений на",
    Code: "Код",
    "Verify Email Address": "Підтвердити електронну пошту",
    "Verify Phone Number": "Підтвердити номер телефону",
    "Request new code": "Запит нового коду",
    wait: "очікування",
    Email: "Електронна пошта",
    "Phone Number": "Номер телефону",
    "User not found": "Користувача не знайдено",
    "Filter countries...": "Фільтр країн...",
    "Filter...": "Фільтр...",
    "Login to your account": "Увійти до вашого облікового запису",
    "Invitation Code": "Код приєднання",
    "Continue with email": "Продовжити з електронною поштою",
    "Continue with phone": "Продовжити з номером телефону",
    "Enter your email to create an account and get started":
      "Введіть свою електронну пошту, щоб створити обліковий запис та почати",
  },
  ku: {
    "Enter your email address to get started":
      "Navnîşana e-nameya xwe binivîse da ku dest pê bike",
    "Enter your phone number to get started":
      "Hejmara telefona xwe binivîse da ku dest pê bike",
    "Failed to send OTP to email": "OTP nehat şandin ji bo e-nameyê",
    "Failed to send OTP to phone": "OTP nehat şandin ji bo telefonê",
    "Sign in with email": "Bi e-nameyê têkeve",
    "Sign in with phone": "Bi telefonê têkeve",
    "By continuing, you acknowledge High Five Academy’s":
      "Bi domandinê, tu polîtîkaya nepenîtiyê ya High Five Academy dipejirînî",
    "Privacy Policy": "Polîtîkaya Nepenîtiyê",
    "Learn whatever you need to": "Hîn bibin çi ku hûn hewce ne",
    "Not a High Five Academy member yet?":
      "Hîn ne endamê High Five Academy yî?",
    "Learn more": "Zêdetir hîn bibin",
    "Enter the verification code sent to":
      "Koda verastkirinê ya ku ji te re hatî şandin binivîse",
    Code: "Kod",
    "Verify Email Address": "Navnîşana E-nameyê verast bike",
    "Verify Phone Number": "Hejmara Telefonê verast bike",
    "Request new code": "Koda nû bixwaze",
    wait: "li bendê be",
    Email: "E-name",
    "Phone Number": "Hejmara Telefonê",
    "User not found": "Bikarhêner nehat dîtin",
    "Filter countries...": "Welatan parzûn bike...",
    "Filter...": "Parzûn...",
    "Login to your account": "Têkeve hesabê xwe",
    "Invitation Code": "Koda Vexwendinê",
    "Continue with email": "Bi e-nameyê berdewam bike",
    "Continue with phone": "Bi telefonê berdewam bike",
    "Enter your email to create an account and get started":
      "E-nameya xwe binivîse da ku hesabek çêbike û dest pê bike",
  },
};

export default translations;
